<div class="autocomplete-wrapper position-relative">
  <div class="input-group">
    <input type="text" class="form-control rounded-pill" placeholder="Enter location" [(ngModel)]="query"
      (input)="onInputChange()" (focus)="showDropdown = true" (blur)="onBlur()">

    <div class="autocomplete-dropdown shadow-sm" *ngIf="showDropdown && filteredOptions.length > 0">
      <div class="autocomplete-item" *ngFor="let option of filteredOptions" (mousedown)="selectOption(option)">
        {{ option.label }} {{ option.description }}
      </div>
    </div>

    <button class="btn btn-primary" type="button" (click)="getCoordinates()" style="width: 4rem;">
      <fa-icon *ngIf="!isLoading" [icon]="fa.faLocationArrow"
        style="margin-left: auto; margin-right: auto; color: #fff;"></fa-icon>
      <fa-icon *ngIf="isLoading" [icon]="fa.faSpinner" [spin]="true"
        style="margin-left: auto; margin-right: auto; color: #fff;"></fa-icon>
    </button>
  </div>